// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14LIj","name":"styles_name__2w7RF","phone":"styles_phone__1VSUM"};